import React, { useContext, useEffect, useState } from "react";
import moment from 'moment-timezone';
import { EmpdContext, EmpdProvider } from "../../../../../Context";
import { TextField } from '@mui/material'
import Autocomplete from '@mui/material/Autocomplete';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { CursorGrowIcon, PlusIcon, MinusIcon } from '../../../../../Components/NumberComponents'
import { NumberField } from '@base-ui-components/react/number-field';
import Card from "../../../../../Components/Card";
import Button from "../../../../../Components/Button";
import { hideField } from '../../../../../utils'
import VirtualizedSelect from '../../../../../Components/VirtualizedSelect';
import AsyncSelect from '../../../../../Components/AsyncSelect';
import numberFieldStyles from '../../../../../Styles/numberFieldStyles.module.css';

moment.tz.setDefault(moment.tz.guess())

interface Props {
    classes?: any,
}

const getSelectorValue = (updateFields: any, field: any, fullDatabaseFieldName: string, instance: number, patientResult: any) => {
    let valueIn: any
    if( updateFields[patientResult.fullDatabaseFieldName] ) {
        if( updateFields[field.fullDatabaseFieldName].hasOwnProperty('repeatInstrument') ) {
            if( Array.isArray(updateFields[field.fullDatabaseFieldName][instance].value) ) {
                valueIn = updateFields[field.fullDatabaseFieldName][instance].value.map((value: any) => field.options.find((element: any) => element.value === value))
            } else {
                valueIn = field.options.find((element: any) => element.value === updateFields[field.fullDatabaseFieldName][instance].value)
            }
        } else if( updateFields[patientResult.fullDatabaseFieldName].hasOwnProperty('options'))  {
            if( Array.isArray(updateFields[field.fullDatabaseFieldName].value) ) {
                valueIn = updateFields[field.fullDatabaseFieldName].value.map((value: any) => updateFields[field.fullDatabaseFieldName].options.find((element: any) => element.value === value))
            } else {
                if( updateFields[field.fullDatabaseFieldName].value !== null ) {
                    if( updateFields[field.fullDatabaseFieldName].hasOwnProperty('options') ) {

                        valueIn = updateFields[field.fullDatabaseFieldName].options.find((element: any) => {
                            return element.value === updateFields[field.fullDatabaseFieldName].value.value
                        })
                    } else {
                        valueIn = updateFields[field.fullDatabaseFieldName].value.value
                    }
                } else {
                    valueIn = null
                }
            }
        } else {
            if( Array.isArray(updateFields[field.fullDatabaseFieldName].value) ) {
                valueIn = updateFields[field.fullDatabaseFieldName].value.map((value: any) => field.options.find((element: any) => element.value === value))
            } else {
                if( updateFields[field.fullDatabaseFieldName].value !== null ) {
                    if( field.hasOwnProperty('options') ) {
                        valueIn = field.options.find((element: any) => {
                            return element.value === updateFields[field.fullDatabaseFieldName].value.value
                        })
                    } else {
                        valueIn = updateFields[field.fullDatabaseFieldName].value.value
                    }
                } else {
                    valueIn = null
                }
            }
        }
    } else if( patientResult.hasOwnProperty('value') ) {
        const value = field.value
        if( field.hasOwnProperty('repeatInstrument') ) {
            valueIn = field.options.find((element: any) => element.label === value[instance])
        } else if( Array.isArray(field.value) ) {
            valueIn = field.value.map((value: any) => field.options.find((element: any) => element.label === value))
        } else if( field.hasOwnProperty('options') ) {
            valueIn = field.options.find((element: any) => element.label === field.value)
            valueIn = valueIn === undefined ? null : valueIn
        } else if( patientResult.editableType === 'lookup' ) {
           valueIn = { label: field.value ? field.value : '', value: field.value ? field.value : ''}
        } else {
            valueIn = field.value
        }
    } else {
        valueIn = null
    }

    return valueIn
}

const renderDataElement = (patientResult: any, patientResults: any, updateFields: any, setUpdateFields: (value: any) => void, setChangesMade: (value: any) => void, activeMrn: string, activeInstance: any, setActiveInstance: (value: any) => void, schemaName: string | undefined, careTable: string | undefined) => {
    if( hideField(patientResult, patientResults, updateFields) ) {
        return
    }

    let value = patientResult.hasOwnProperty('value') ? patientResult.value : 'No Data'
    const fullDatabaseFieldName = patientResult.fullDatabaseFieldName
    const type = patientResult.editableType
    let fieldName = patientResult.field_label.trim()
    const field = { name: fieldName, ...patientResult}

    const repeatInstrument:string = patientResult.repeatInstrument
    let instance: number = 0
    if( repeatInstrument && activeInstance.hasOwnProperty(repeatInstrument)) {
        instance = activeInstance[repeatInstrument].activeInstance
        value = value[instance]
    }
    
    if( type === 'lookup') {
        let valueIn = getSelectorValue(updateFields, field, fullDatabaseFieldName, instance, patientResult)
        return (
             <div className='row' key={fullDatabaseFieldName}>
                <div className="smart-col-content-label long-label" key={fullDatabaseFieldName} data-testid={`test-${fullDatabaseFieldName}`}>
                    <strong>{fieldName}:</strong>
                </div>
                <AsyncSelect 
                    multiple={patientResult.isMultiSelect}
                    sx={{
                        width: 500,
                        "& .MuiOutlinedInput-root": {
                            color: "#002F6C",
                            // Class for the border around the input field
                            "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#002F6C",
                                borderWidth: "2px",
                            },
                            "& .MuiOutlineInput-focused": {
                                color: "#108de0",
                            },
                        },
                        "& .MuiChip-root": {
                            color: "#002F6C",
                        },
                        // Class for the label ofthe input field
                        "& .MuiInputLabel-outlined": {
                            color: "#777777",
                        },

                    }}
                    ontology={patientResult.parameters.ontology}
                    onChange={(event: React.SyntheticEvent, value: any) => {
                        const updateFieldsCopy = { ...updateFields}
                        if( patientResult.isMultiSelect ) {
                            updateFieldsCopy[patientResult.fullDatabaseFieldName] = {
                                fieldName: patientResult.fullDatabaseFieldName,
                                value: event ? value.map((option: any) => option.value) : [],
                                options: event ? value.map((option: any) => ({ label: option.label, value: option.value })) : []
                            }
                        } else {
                            updateFieldsCopy[patientResult.fullDatabaseFieldName] = {
                                fieldName: patientResult.fullDatabaseFieldName,
                                value: event ? value : null,
                                options: [value]
                            }
                        }
                        setChangesMade(true)
                        setUpdateFields(updateFieldsCopy)
                    }}
                    value={valueIn}
                    label={fieldName}

                /> 
             </div>
        )
    } else if( type === 'selector' ) {
        let valueIn = getSelectorValue(updateFields, field, fullDatabaseFieldName, instance, patientResult)
        const options = patientResult.options.map((option: any) => {
            return { label: option.label, value: option.value }
        })

        return (
            <div className='row' key={fullDatabaseFieldName}>
                <div className="smart-col-content-label long-label" key={fullDatabaseFieldName} data-testid={`test-${fullDatabaseFieldName}`}>
                    <strong>{fieldName}:</strong>
                </div>        
                <VirtualizedSelect
                    multiple={patientResult.isMultiSelect}
                    sx={{
                        width: 500,
                        "& .MuiOutlinedInput-root": {
                            color: "#002F6C",
                            // Class for the border around the input field
                            "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#002F6C",
                                borderWidth: "2px",
                            },
                            "& .MuiOutlineInput-focused": {
                                color: "#108de0",
                            },
                        },
                        "& .MuiChip-root": {
                            color: "#002F6C",
                        },
                        // Class for the label ofthe input field
                        "& .MuiInputLabel-outlined": {
                            color: "#777777",
                        },
                    }}
                    options={options}
                    onChange={(event: React.SyntheticEvent, value: any) => {
                        const updateFieldsCopy = { ...updateFields}

						if( value === null ) {
							delete updateFieldsCopy[patientResult.fullDatabaseFieldName]
							if( patientResult.fullDatabaseFieldName === `${schemaName}.${careTable}.treating_md` ) {
								delete updateFieldsCopy[`${schemaName}.${careTable}.treating_md_e_mail`]
							}

							if( patientResult.fullDatabaseFieldName === `${schemaName}.${careTable}.treating_md_e_mail` ) {
								delete updateFieldsCopy[`${schemaName}.${careTable}.treating_md`]
							}
						} else if( patientResult.isMultiSelect ) {
                            updateFieldsCopy[patientResult.fullDatabaseFieldName] = {
                                fieldName: patientResult.fullDatabaseFieldName,
                                value: event ? value.map((option: any) => option.value) : []
                            }
                        } else {
                            updateFieldsCopy[patientResult.fullDatabaseFieldName] = {
                                fieldName: patientResult.fullDatabaseFieldName,
                                value: event ? value : null
                            }

							if( patientResult.fullDatabaseFieldName === `${schemaName}.${careTable}.treating_md` ) {
								const linkedOption = patientResults.columns.find((column: any) => column.fullDatabaseFieldName === `${schemaName}.${careTable}.treating_md_e_mail`).options.find((option: any) => option.value === value.value)
								updateFieldsCopy[`${schemaName}.${careTable}.treating_md_e_mail`] = {
									fieldName: `${schemaName}.${careTable}.treating_md_e_mail`,
									value: linkedOption
								}
							}

							if( patientResult.fullDatabaseFieldName === `${schemaName}.${careTable}.treating_md_e_mail` ) {
								const linkedOption = patientResults.columns.find((column: any) => column.fullDatabaseFieldName === `${schemaName}.${careTable}.treating_md`).options.find((option: any) => option.value === value.value)
								updateFieldsCopy[`${schemaName}.${careTable}.treating_md`] = {
									fieldName: `${schemaName}.${careTable}.treating_md`,
									value: linkedOption
								}
							}
							
                        }

                        setChangesMade(true)
                        setUpdateFields(updateFieldsCopy)
                    }}
                    value={valueIn}
                    label={fieldName}
                />
{/*
                <Autocomplete
                    multiple={patientResult.isMultiSelect}
                    filterOptions={(options: any, state: any) => {
                        if( patientResult.isMultiSelect ) {
                            const excludedOptions = valueIn.map((element: any) => element.value)
                            return options.filter((item:any) => !excludedOptions.includes(item.value))
                        } else {
                            return options
                        }
                    }}
                    sx={{
                        width: 500,
                        "& .MuiOutlinedInput-root": {
                            color: "#002F6C",
                            // Class for the border around the input field
                            "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#002F6C",
                                borderWidth: "2px",
                            },
                            "& .MuiOutlineInput-focused": {
                                color: "#108de0",
                            },
                        },
                        "& .MuiChip-root": {
                            color: "#002F6C",
                        },
                        // Class for the label ofthe input field
                        "& .MuiInputLabel-outlined": {
                            color: "#777777",
                        },

                    }}
                    onChange={(event: React.SyntheticEvent, value: any) => {
                        const updateFieldsCopy = { ...updateFields}
                        if( patientResult.isMultiSelect ) {
                            updateFieldsCopy[patientResult.fullDatabaseFieldName] = {
                                fieldName: patientResult.fullDatabaseFieldName,
                                value: event ? value.map((option: any) => option.value) : []
                            }
                        } else {
                            updateFieldsCopy[patientResult.fullDatabaseFieldName] = {
                                fieldName: patientResult.fullDatabaseFieldName,
                                value: event ? value : null
                            }
                        }
                        setChangesMade(true)
                        setUpdateFields(updateFieldsCopy)
                  }}
                  renderInput={(params) => <TextField {...params} label={fieldName}/>}
                  options={options}
                  value={valueIn}
                />
                */}
            </div>
        )
    } else if( type === 'numericInput') {
        return (
            <div className='row' key={fullDatabaseFieldName}>
                <div className="smart-col-content-label long-label" key={fullDatabaseFieldName}>
                   <strong>{fieldName}:</strong>
                </div>
                <NumberField.Root id={fieldName}
                    value={updateFields[fullDatabaseFieldName] ? updateFields[fullDatabaseFieldName].value : value ? value : 0}
                    className={numberFieldStyles.Field}
                    onValueChange={(value: number | null) => {
                        const updateFieldsCopy = { ...updateFields}
                        updateFieldsCopy[fullDatabaseFieldName] = {
                            fieldName: fullDatabaseFieldName,
                            value: value
                        }
                        setUpdateFields(updateFieldsCopy)
                        setChangesMade(true)

                    }}
                >
                    <NumberField.ScrubArea className={numberFieldStyles.ScrubArea}>
                        <label htmlFor={fieldName} className={numberFieldStyles.Label}>
                            {fieldName}
                        </label>
                        <NumberField.ScrubAreaCursor className={numberFieldStyles.ScrubAreaCursor}>
                            <CursorGrowIcon />
                        </NumberField.ScrubAreaCursor>
                    </NumberField.ScrubArea>

                    <NumberField.Group className={numberFieldStyles.Group}>
                        <NumberField.Decrement className={numberFieldStyles.Decrement}>
                            <MinusIcon />
                        </NumberField.Decrement>
                        <NumberField.Input className={numberFieldStyles.Input} />
                        <NumberField.Increment className={numberFieldStyles.Increment}>
                            <PlusIcon />
                        </NumberField.Increment>
                    </NumberField.Group>
                </NumberField.Root>
            </div>
        )
    } else if( type === 'string' ) {
        const content = updateFields[fullDatabaseFieldName] ? updateFields[fullDatabaseFieldName].value : (value !== undefined && value !== null) ? value.toString() : ''
        return (
            <div className='row' key={fullDatabaseFieldName}>
                <div className='smart-col-content-label long-label' key={`${fullDatabaseFieldName}-label`}>
                    <strong>{fieldName}:</strong>
                </div>
                <TextField key={`${fullDatabaseFieldName}-component`}
                    data-testid={`test-${fullDatabaseFieldName}`}
                    label={fieldName}
                    sx={{
                        width: 500,
                        "& .MuiOutlinedInput-root": {
                            color: "#000",
                            // Class for the border around the input field
                            "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#002F6C",
                                borderWidth: "2px",
                            },
                        },
                        // Class for the label ofthe input field
                        "& .MuiInputLabel-outlined": {
                            color: "#777777",
                        },
                        "& .MuiOutlinedInput-input": {
                            color: "#002F6C",
                        },
                    }}
                    type='text'
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        const updateFieldsCopy = { ...updateFields}
                        updateFieldsCopy[fullDatabaseFieldName] = {
                            fieldName: fullDatabaseFieldName,
                            value: e.target.value
                        }
                        setUpdateFields(updateFieldsCopy)
                        setChangesMade(true)
                    }}
                    InputProps={{
                        style:{
                            color: '#777777',
                        }
                    }}
                    value={content}
                />
            </div>
        )
    } else if( type === 'date' ) {
        let date
        if( value ) {
            date = moment(moment(value).tz('UTC').format('YYYY-MM-DD')).tz('UTC')
        }

        return (
            <div className='row' key={fullDatabaseFieldName}>
                <div className="smart-col-content-label long-label" key={fieldName} >
                    <strong>{fieldName}:</strong>
                </div>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                        sx={{
                        width: 500,
                        "& .MuiPickersOutlinedInput-root": {
                                color: "#002F6C",
                                // Class for the border around the input field
                                "& .MuiPickersOutlinedInput-notchedOutline": {
                                    borderColor: "#002F6C",
                                    borderWidth: "2px",
                                },
                            },
                            // Class for the label ofthe input field
                            "& .MuiInputLabel-outlined": {
                                color: "#777777",
                            },
                        }}
                        //className='smart-col-content-element'
                        onChange={(selectedOption: any) => {
                            const updateFieldsCopy = { ...updateFields}
                            updateFieldsCopy[`${fullDatabaseFieldName}`] = {
                                fieldName: `${fullDatabaseFieldName}`,
                                value: moment(selectedOption).tz('UTC')
                            }
                            setUpdateFields(updateFieldsCopy)
                            setChangesMade(true)
                        }}
                        label={fieldName}
                        value={updateFields[`${fullDatabaseFieldName}`] ? updateFields[`${fullDatabaseFieldName}`].value : date ? date : null}
                    />
                </LocalizationProvider>
            </div>
        )
    } else if( type === 'boolean' ) {
        let value = getSelectorValue(updateFields, field, fullDatabaseFieldName, instance, patientResult)
        if( value !== null ) {
            if( value === true ) {
                value = 'Yes'
            } else {
                value = 'No'
            }
        } else {
            value = null
        }

        return (
            <div className='row' key={fullDatabaseFieldName}>
                <div className="smart-col-content-label long-label" key={fullDatabaseFieldName} data-testid={`test-${fullDatabaseFieldName}`}>
                    <strong>{fieldName}:</strong>
                </div>
                <Autocomplete
                    sx={{
                        width: 500,
                        "& .MuiOutlinedInput-root": {
                            color: "#002F6C",
                            // Class for the border around the input field
                            "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#002F6C",
                                borderWidth: "2px",
                            },
                        },
                        // Class for the label ofthe input field
                        "& .MuiInputLabel-outlined": {
                            color: "#002F6C",
                        },
                    }}
                    onChange={(event: React.SyntheticEvent, value: any) => {
                        const updateFieldsCopy = { ...updateFields}
                        updateFieldsCopy[patientResult.fullDatabaseFieldName] = {
                            fieldName: patientResult.fullDatabaseFieldName,
                            value: event ? value : null
                        }
                        setChangesMade(true)
                        setUpdateFields(updateFieldsCopy)
                  }}
                  renderInput={(params) => <TextField {...params} label={fieldName} />}
                  options={[{ label: 'Yes', value: true },
                            { label: 'No', value: false }]}
                  value={value}
                />

            </div>
        )
    }else {
        if( fieldName.toLowerCase().includes('date') ) {
            if( value && !(value === 'None' || value === 'No Data') ) {
                value = moment(moment(value).tz('UTC').format('YYYY-MM-DD')).tz('UTC').format('YYYY-MM-DD')
            }
        }

        if( value !== null ) {
            if( value === true ) {
                value = 'Yes'
            } else if( value === false ) {
                value = 'No'
            }
        } else {
            value = 'No Data'
        }

        return (
            <div className='row' key={fieldName}>
                <div className="smart-col-content-label long-label" key={fieldName} >
                  <p><strong>{fieldName}:</strong></p>
                </div>
                <div className="smart-col-content-label long-label" >
                    <p data-testid={`test-${fullDatabaseFieldName}`}>
                        {value}
                    </p>
                </div>
            </div>
        )
    }
}

const generateCategorySelects = (data: any, categories: string[], selectedCategory: any | null, setSelectedCategory: (value: string | null) => void) => {
    if( categories && categories.length > 0 ) {
        return (
            <Autocomplete
                sx={{
                    width: 300,
                    "& .MuiOutlinedInput-root": {
                        color: "#002F6C",
                        // Class for the border around the input field
                        "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#002F6C",
                            borderWidth: "2px",
                        },
                    },
                    "& .MuiChip-root": {
                        color: "#002F6C",
                    },
                    // Class for the label ofthe input field
                    "& .MuiInputLabel-outlined": {
                        color: "#002F6C",
                    },
                }}
                onChange={(event: React.SyntheticEvent, value: any) => {
                    if( value ) {
                        setSelectedCategory(value)
                    } else {
                        setSelectedCategory(null)
                    }
                }}
                renderInput={(params) => <TextField {...params} label={'Category'} />}
                options={categories.map((category: string) => { return {label: category, id: category}})}
                value={selectedCategory}
            />
        )
    }
}

const renderHeader = (classes: any, patientResult: any, data: any, authUser: any, isLoading: boolean, updateFields: any, setUpdateFields: (value: any) => void, changesMade: boolean, setChangesMade: (value: any) => void, selectedCategory: any | null, setSelectedCategory: (value: string | null) => void, pdfModalOpen: boolean, setPdfModalOpen: (value: boolean) => void, activeInstance: number, setActiveInstance: (value: any) => void, writePatientData: () => void, writeComplete:(category:string| null) => void, isResearchParticipant: boolean, schemaName: string | undefined, careTable: string | undefined) => {

    if( isLoading || !isResearchParticipant) {
        return (
            <div>
                'still loading'
            </div>
        )
    }

    if( authUser && Object.keys(patientResult).length > 0 && data) {
      if( patientResult.categories['General Demography'] === undefined ) {
          return (
              <div>
                No data available
              </div>
          )
      }

      return (
        <div key='pdf-modal'>
            {data.categories && (
                <div key='categories'>
                    <div className="card-row-content">
                            <div className="row">
                            {generateCategorySelects(data.categories, Object.keys(data.categories), selectedCategory, setSelectedCategory)}
                            <Button
                                onClick={() => {
                                    window.location.href = 'mailto:no-reply@example.com'
                                }}
                                label={'Contact the Team'}
                                className={classes.heroButton}
                            />
                        </div>
                    </div>
                    { selectedCategory && (
                    <Card header={selectedCategory.label || ''}>
                        <div className="card-row-content">
                            <div className="row">
                                    <div className="column smart-card-col" key={``} >
                                        {selectedCategory && data && data.categories[selectedCategory.label] && data.categories[selectedCategory.label].records.columns.map((element: any) => {
                                            if( data.categories[selectedCategory.label].records.columns.find((element: any) => element.fullDatabaseFieldName.match(/.*complete/) && element.value === 'Complete') ) {
                                                element.editableType = 'locked'
                                            }

                                            return renderDataElement(element, data.categories[selectedCategory.label].records, updateFields, setUpdateFields, setChangesMade, authUser.username, activeInstance, setActiveInstance, schemaName, careTable)
                                        })}
                                    </div>
                            </div>
                        </div>
                    </Card>
                    )}

                </div>
            )}
        </div>
      );
    }
};

const useMyContext = () => {
    const context = useContext(EmpdContext)
    if( !context ) {
        throw new Error("No provider found for Context")
    }
    return context
}

// This component displays patient data from context
const PatientData = ({ classes }: Props) => {

    const { authUser, isLoading, patientResult, updateFields, setUpdateFields, changesMade, setChangesMade, setActiveMrn, writePatientData, writeComplete, isResearchParticipant, selectedCategory, setSelectedCategory, mergeData, schemaName, careTable } = useMyContext()
    const [ data, setData ] = useState(null)
    const [ pdfModalOpen, setPdfModalOpen ] = useState(false)
    const [ activeInstance, setActiveInstance ] = useState(0)

    useEffect(() => {
        if (authUser && !isLoading && Object.keys(patientResult).length > 0) {
            let mergedData =  mergeData(patientResult)
            setData(mergedData)
            setActiveMrn(patientResult.patientQuery.value)
        }
    }, [authUser, isLoading, patientResult ])


    return (
        <EmpdProvider>
            {renderHeader(classes, patientResult, data, authUser, isLoading, updateFields, setUpdateFields, changesMade, setChangesMade, selectedCategory, setSelectedCategory, pdfModalOpen, setPdfModalOpen, activeInstance, setActiveInstance, writePatientData, writeComplete, isResearchParticipant, schemaName, careTable)}
        </EmpdProvider>
    );
};

export default PatientData;
